import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { toEsgOnboardingRecord, useEsgOnboardingRun } from '@/features/esg/api/use-esg';
import { EsgOnboardingWorkspace } from '@/features/esg/components/EsgOnboardingWorkspace';

import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/_authenticated/esg/onboarding/$onboardingId')({
  beforeLoad: () => ({
    getTitle: () => 'CSRD Onboarding Workspace',
  }),
  component: EsgOnboardingWorkspaceRoute,
});

function EsgOnboardingWorkspaceRoute() {
  const { t } = useTranslation('common');
  const { onboardingId } = Route.useParams();
  const onboardingRunQuery = useEsgOnboardingRun(onboardingId);

  if (onboardingRunQuery.isLoading) {
    return (
      <div className="p-8">
        <div className="rounded-2xl border border-dashed p-8 text-center">
          <p className="text-base font-medium">{t('common:routeErrors.loadingOnboarding')}</p>
        </div>
      </div>
    );
  }

  const record = onboardingRunQuery.data ? toEsgOnboardingRecord(onboardingRunQuery.data) : null;

  if (!record) {
    return (
      <div className="p-8">
        <div className="rounded-2xl border border-dashed p-8 text-center">
          <p className="text-base font-medium">{t('common:routeErrors.onboardingNotFound')}</p>
          <p className="mt-2 text-sm text-muted-foreground">
            {t('common:routeErrors.onboardingNotAvailable')}
          </p>
          <Button className="mt-4" asChild>
            <Link to="/esg/onboarding">{t('common:routeErrors.backToOnboardingRegistry')}</Link>
          </Button>
        </div>
      </div>
    );
  }

  return <EsgOnboardingWorkspace record={record} />;
}
